const OPTIONS = [
  ["real", "Réel"],
  ["demo", "Démo"],
  ["all", "Tout"],
];

export function ScopeSwitcher({ scope, setScope }) {
  return (
    <div className="flex gap-1 p-1 rounded-lg bg-[#111827] border border-[#1E293B]" data-testid="scope-switcher">
      {OPTIONS.map(([v, l]) => (
        <button
          key={v}
          data-testid={`scope-${v}`}
          onClick={() => setScope(v)}
          className={`px-3 py-1.5 rounded-md text-xs font-semibold transition-colors ${
            scope === v ? "bg-emerald-500 text-[#0B0F17]" : "text-slate-400 hover:text-slate-200"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
}
